import React from "react";
import ImageSection from "../../components/common/ImageSection";
import { FaClock } from "react-icons/fa6";
import { PiMapPinFill } from "react-icons/pi";

const JobDescription = () => {
  return (
    <>
      <ImageSection name={"Job Description"} />
      <section className="relative fonts p-4 md:p-8 lg:p-4 my-5 lg:my-16 xl:pb-14 overflow-hidden">
        <div className="lg:mx-10 xl:mx-14 2xl:mx-[290px] 3xl:mx-[370px] 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="flex flex-col gap-3 2xl:gap-5">
            <div>
              <h3 className="2xl:mb-2 3xl:mb-0 text-[#A5302E] text-lg 2xl:text-2xl 3xl:text-3xl font-normal leading-none 3xl:leading-normal">
                Trainee
              </h3>
              <h1 className="text-[#222222] text-xl lg:text-4xl 2xl:text-[46px] 3xl:text-5xl font-semibold">
                UX and UI Designer (Full Time)
              </h1>
            </div>
            <div className="flex gap-2 lg:gap-4 2xl:gap-6 3xl:gap-10">
              <span className="pr-2 lg:pr-4 2xl:pr-6 3xl:pr-10 flex items-center gap-1 lg:gap-3 border-r border-r-[#929292]">
                <FaClock className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg lg:text-sm 2xl:text-sm" />
                <p className="text-[#222222] text-xs xs:text-xs sm:text-base lg:text-sm xl:text-base font-normal">
                  Full time
                </p>
              </span>
              <span className="pr-2 lg:pr-4 2xl:pr-6 3xl:pr-10 flex items-center gap-1 lg:gap-3 border-r border-r-[#929292]">
                <PiMapPinFill className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:text-xl" />
                <p className="text-[#222222] text-xs xs:text-xs sm:text-base lg:text-sm xl:text-base font-normal">
                  On Site
                </p>
              </span>
              <span className="pr-2 lg:pr-4 2xl:pr-6 3xl:pr-10 flex items-center gap-1 lg:gap-3 border-r border-r-[#929292]">
                <p className="text-[#222222] text-xs xs:text-xs sm:text-base lg:text-sm xl:text-base 2xl:base 3xl:text-lg font-normal">
                  No of vacancies: <span className="text-[#A5302E]">2</span>
                </p>
              </span>
              <span className="flex items-center gap-1 lg:gap-3">
                <p className="text-[#222222] text-xs xs:text-xs sm:text-base lg:text-sm xl:text-base 2xl:base 3xl:text-lg font-normal">
                  Experience: Fresher
                </p>
              </span>
            </div>
            <div className="2xl:my-6 my-8">
              <p className="3xl:text-xl font-normal">
                We’re a collective of thinkers and tinkerers designers,
                engineers, writers, and strategists building the platform to
                change the way apps are built. Our work is inspired by a shared
                belief that app creation should be simple, accessible, and
                enjoyable to everyone on the planet.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-5">
            <div className="space-y-2">
              <h1 className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium">
                About the role
              </h1>
              <p className="text-[#555555] text-sm md:text-base lg:text-base xl:text-lg font-normal space-y-4">
                Are you passionate about creating seamless and visually
                captivating user experiences? We're on the lookout for a
                talented individual to join our team as a Trainee UX and UI
                Designer. As a key member of our collective, you'll have the
                opportunity to contribute to the creation of cutting-edge apps
                and redefine the way users interact with technology.
              </p>
            </div>
            <div className="space-y-2">
              <h1 className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium">
                Career Benefits
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-sm md:text-base lg:text-base xl:text-lg font-normal space-y-2">
                <li>Experiences in docker development techniques.</li>
                <li>
                  Since we are an agile team, you will learn and practice Agile.
                </li>
                <li>Experiences in docker development techniques.</li>
                <li>Opportunities to expand your knowledge.</li>
                <li>A Certificate will be provided after completion.</li>
              </ul>
            </div>
            <div className="space-y-2">
              <h1 className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium">
                Offer Great Benefits.
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-sm md:text-base lg:text-base xl:text-lg font-normal space-y-2">
                <li>Company-wide 401(k) plan</li>
                <li>Life & disability insurance offered</li>
                <li>Ompetitive compensation—salary, bonus, equity</li>
                <li>Medical, dental, and vision; flex spending account</li>
                <li>Flexible paid time off & sick leave</li>
              </ul>
            </div>
            <div className="space-y-2">
              <h1 className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium">
                Educational Requirements{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-sm md:text-base lg:text-base xl:text-lg font-normal space-y-2">
                <li>
                  Experiences in competitive programming will get priority
                  access.
                </li>
                <li>
                  Bachelor of Science (BSc) in Computer Science & Engineering or
                  equivalent field.
                </li>
                <li>
                  A good profile with StackOverflow and Hackathon will get
                  priority access
                </li>
              </ul>
            </div>
            <div className="space-y-2">
              <h1 className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium">
                Salary range{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-sm md:text-base lg:text-base xl:text-lg font-normal space-y-2">
                <li>$80k to $100k (Based on your Performance).</li>
              </ul>
            </div>
            <div className="space-y-2">
              <h1 className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium">
                Working days{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-sm md:text-base lg:text-base xl:text-lg font-normal space-y-2">
                <li>
                  Weekly 05 days. Sunday To Thursday. 09 AM to 06 PM.(Launch
                  Break 01 Hour)
                </li>
              </ul>
            </div>
            <div className="space-y-2">
              <h1 className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium">
                Application Deadline{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-sm md:text-base lg:text-base xl:text-lg font-normal space-y-2">
                <li>January 01, 2024</li>
              </ul>
            </div>
            <div className="space-y-2">
              <a
                href="/"
                className="text-[#A5302E] text-lg md::text-xl lg:text-2xl font-medium underline uppercase"
              >
                Please, upload your CV in PDF format.
              </a>
            </div>
            <div className="lg:mt-4">
              <button
                className=" py-3 px-8 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-3 lg:px-10 hover:lg:py-3 hover:lg:px-10 bg-[#A5302E]
                   text-[#fff] border border-transparent hover:bg-transparent hover:border hover:border-[#A5302E] hover:text-[#A5302E]
                   text-sm sm:text-base md:text-lg lg:text-base 3xl:text-[22px] transition"
              >
                Apply for this position
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JobDescription;
